import { z } from 'zod'

import { classroomReferrerSchema } from './classroom-params'

export const prestudyRoomUrlParamsSchema = z.object({
  roomId: z.string().min(1),
  referrer: classroomReferrerSchema.optional(),
  originals: z.record(z.string(), z.string().or(z.number()).optional()).optional(),
})

export type PrestudyRoomParams = z.infer<typeof prestudyRoomUrlParamsSchema>
